module.exports = __webpack_public_path__ + "img/icon-23.6fb86bb1.svg";